// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: block;
  -webkit-tap-highlight-color: transparent;
}

.embed-preview-dialog {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-width: 720px;
  max-height: min(90vh, 100dvh);
  min-height: 0;
  box-sizing: border-box;
  background: #ffffff !important;
  border-radius: 12px !important;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);
  overflow: hidden !important;
  font-family: "Raleway", Arial, Helvetica, sans-serif;
  margin: 0 !important;
  padding: 0 !important;
}
.embed-preview-dialog .dialog-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 16px 20px;
  background: #ffffff !important;
  color: #1a1a1a;
  border-bottom: 1px solid #e0e0e0;
  border-radius: 12px 12px 0 0 !important;
  flex-shrink: 0;
}
.embed-preview-dialog .dialog-header .dialog-title {
  margin: 0;
  padding: 0;
  font-size: clamp(16px, 4.2vw, 20px);
  font-weight: 600;
  line-height: 1.3;
  color: #0f172a;
}
.embed-preview-dialog .dialog-header .close-button {
  color: #6b7280;
  width: 44px;
  height: 44px;
  min-width: 44px;
  min-height: 44px;
  border-radius: 50%;
  flex-shrink: 0;
}
.embed-preview-dialog .dialog-header .close-button:hover {
  background: #f3f4f6;
  color: #374151;
}
.embed-preview-dialog .dialog-header .close-button mat-icon {
  font-size: 22px;
  width: 22px;
  height: 22px;
}
.embed-preview-dialog .dialog-content {
  flex: 1 1 auto;
  min-width: 0;
  overflow-x: hidden;
  overflow-y: auto;
  padding: 20px;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  background: #ffffff !important;
  -webkit-overflow-scrolling: touch;
}
.embed-preview-dialog .dialog-content app-embed-preview {
  display: block;
  width: 100%;
  min-width: 0;
  max-width: 100%;
}
.embed-preview-dialog .preview-frame-wrap {
  position: relative;
  max-width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  overflow: hidden;
  background: #f8fafc;
  box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);
}
.embed-preview-dialog .preview-frame-wrap iframe {
  display: block;
  border: 0;
  max-width: 100%;
  background: #fff;
}
.embed-preview-dialog .preview-frame-wrap iframe.is-hidden {
  opacity: 0;
  visibility: hidden;
}
.embed-preview-dialog .preview-loader {
  position: absolute;
  inset: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 14px;
  background: #f8fafc;
}
.embed-preview-dialog .preview-loader p {
  margin: 0;
  font-size: 14px;
  font-weight: 500;
  color: #4b5563;
}
@media (max-width: 700px) {
  .embed-preview-dialog {
    max-width: 100%;
    max-height: 100dvh;
    border-radius: 0 !important;
  }
  .embed-preview-dialog .dialog-header {
    border-radius: 0 !important;
    padding: 14px 12px 14px 16px;
  }
  .embed-preview-dialog .dialog-content {
    padding: 12px;
    overflow-x: hidden;
  }
  .embed-preview-dialog .preview-frame-wrap {
    width: 100% !important;
    height: auto !important;
    min-height: 200px;
    aspect-ratio: 16/9;
  }
  .embed-preview-dialog .preview-frame-wrap iframe {
    width: 100% !important;
    height: 100% !important;
  }
}

:host ::ng-deep .preview-loader .mat-mdc-progress-spinner circle {
  stroke: #5ea1d8;
}

:host-context(body.theme-dark) .embed-preview-dialog,
:host-context(body.theme-dark) .embed-preview-dialog .dialog-header,
:host-context(body.theme-dark) .embed-preview-dialog .dialog-content {
  background: #111827 !important;
  color: #e2e8f0 !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .embed-preview-dialog .dialog-title,
:host-context(body.theme-dark) .embed-preview-dialog .close-button,
:host-context(body.theme-dark) .embed-preview-dialog .close-button mat-icon {
  color: #e2e8f0 !important;
}
:host-context(body.theme-dark) .embed-preview-dialog .close-button:hover {
  background: rgba(148, 163, 184, 0.12) !important;
  color: #f8fafc !important;
}
:host-context(body.theme-dark) .embed-preview-dialog .preview-frame-wrap,
:host-context(body.theme-dark) .embed-preview-dialog .preview-loader {
  background: #0f172a !important;
  border-color: rgba(148, 163, 184, 0.3) !important;
}
:host-context(body.theme-dark) .embed-preview-dialog .preview-loader p {
  color: #cbd5e1 !important;
}
:host-context(body.theme-dark) .embed-preview-dialog mat-icon,
:host-context(body.theme-dark) .embed-preview-dialog .mat-icon {
  color: #e2e8f0 !important;
  fill: currentColor !important;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/embeded/embed-preview-dialog.component.scss"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,wCAAA;AACF;;AAEA;EACE,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,8BAAA;EACA,8BAAA;EACA,0CAAA;EACA,2BAAA;EACA,oDAAA;EACA,oBAAA;EACA,qBAAA;AACF;AACE;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,4BAAA;EACA,8BAAA;EACA,cAAA;EACA,gCAAA;EACA,uCAAA;EACA,cAAA;AACJ;AACI;EACE,SAAA;EACA,UAAA;EACA,mCAAA;EACA,gBAAA;EACA,gBAAA;EACA,cAAA;AACN;AAEI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AAAN;AAEM;EACE,mBAAA;EACA,cAAA;AAAR;AAGM;EACE,eAAA;EACA,WAAA;EACA,YAAA;AADR;AAME;EACE,cAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,8BAAA;EACA,iCAAA;AAJJ;AAMI;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;AAJN;AAQE;EACE,kBAAA;EACA,eAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,kDAAA;AANJ;AAQI;EACE,cAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;AANN;AAQM;EACE,UAAA;EACA,kBAAA;AANR;AAWE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,mBAAA;AATJ;AAWI;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;AATN;AAaE;EAvHF;IAwHI,eAAA;IACA,kBAAA;IACA,2BAAA;EAVF;EAYE;IACE,2BAAA;IACA,4BAAA;EAVJ;EAaE;IACE,aAAA;IACA,kBAAA;EAXJ;EAcE;IACE,sBAAA;IACA,uBAAA;IACA,iBAAA;IACA,kBAAA;EAZJ;EAeE;IACE,sBAAA;IACA,uBAAA;EAbJ;AACF;;AAiBA;EACE,eAAA;AAdF;;AAkBE;;;EAGE,8BAAA;EACA,yBAAA;EACA,iDAAA;AAfJ;AAkBE;;;EAGE,yBAAA;AAhBJ;AAmBE;EACE,gDAAA;EACA,yBAAA;AAjBJ;AAoBE;;EAEE,8BAAA;EACA,iDAAA;AAlBJ;AAqBE;EACE,yBAAA;AAnBJ;AAsBE;;EAEE,yBAAA;EACA,6BAAA;AApBJ","sourcesContent":[":host {\n  display: block;\n  -webkit-tap-highlight-color: transparent;\n}\n\n.embed-preview-dialog {\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  max-width: 720px;\n  max-height: min(90vh, 100dvh);\n  min-height: 0;\n  box-sizing: border-box;\n  background: #ffffff !important;\n  border-radius: 12px !important;\n  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.12);\n  overflow: hidden !important;\n  font-family: \"Raleway\", Arial, Helvetica, sans-serif;\n  margin: 0 !important;\n  padding: 0 !important;\n\n  .dialog-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    padding: 16px 16px 16px 20px;\n    background: #ffffff !important;\n    color: #1a1a1a;\n    border-bottom: 1px solid #e0e0e0;\n    border-radius: 12px 12px 0 0 !important;\n    flex-shrink: 0;\n\n    .dialog-title {\n      margin: 0;\n      padding: 0;\n      font-size: clamp(16px, 4.2vw, 20px);\n      font-weight: 600;\n      line-height: 1.3;\n      color: #0f172a;\n    }\n\n    .close-button {\n      color: #6b7280;\n      width: 44px;\n      height: 44px;\n      min-width: 44px;\n      min-height: 44px;\n      border-radius: 50%;\n      flex-shrink: 0;\n\n      &:hover {\n        background: #f3f4f6;\n        color: #374151;\n      }\n\n      mat-icon {\n        font-size: 22px;\n        width: 22px;\n        height: 22px;\n      }\n    }\n  }\n\n  .dialog-content {\n    flex: 1 1 auto;\n    min-width: 0;\n    overflow-x: hidden;\n    overflow-y: auto;\n    padding: 20px;\n    display: flex;\n    justify-content: center;\n    align-items: flex-start;\n    background: #ffffff !important;\n    -webkit-overflow-scrolling: touch;\n\n    app-embed-preview {\n      display: block;\n      width: 100%;\n      min-width: 0;\n      max-width: 100%;\n    }\n  }\n\n  .preview-frame-wrap {\n    position: relative;\n    max-width: 100%;\n    border: 1px solid #e0e0e0;\n    border-radius: 8px;\n    overflow: hidden;\n    background: #f8fafc;\n    box-shadow: inset 0 0 0 1px rgba(15, 23, 42, 0.04);\n\n    iframe {\n      display: block;\n      border: 0;\n      max-width: 100%;\n      background: #fff;\n\n      &.is-hidden {\n        opacity: 0;\n        visibility: hidden;\n      }\n    }\n  }\n\n  .preview-loader {\n    position: absolute;\n    inset: 0;\n    z-index: 2;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 14px;\n    background: #f8fafc;\n\n    p {\n      margin: 0;\n      font-size: 14px;\n      font-weight: 500;\n      color: #4b5563;\n    }\n  }\n\n  @media (max-width: 700px) {\n    max-width: 100%;\n    max-height: 100dvh;\n    border-radius: 0 !important;\n\n    .dialog-header {\n      border-radius: 0 !important;\n      padding: 14px 12px 14px 16px;\n    }\n\n    .dialog-content {\n      padding: 12px;\n      overflow-x: hidden;\n    }\n\n    .preview-frame-wrap {\n      width: 100% !important;\n      height: auto !important;\n      min-height: 200px;\n      aspect-ratio: 16 / 9;\n    }\n\n    .preview-frame-wrap iframe {\n      width: 100% !important;\n      height: 100% !important;\n    }\n  }\n}\n\n:host ::ng-deep .preview-loader .mat-mdc-progress-spinner circle {\n  stroke: #5ea1d8;\n}\n\n:host-context(body.theme-dark) {\n  .embed-preview-dialog,\n  .embed-preview-dialog .dialog-header,\n  .embed-preview-dialog .dialog-content {\n    background: #111827 !important;\n    color: #e2e8f0 !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .embed-preview-dialog .dialog-title,\n  .embed-preview-dialog .close-button,\n  .embed-preview-dialog .close-button mat-icon {\n    color: #e2e8f0 !important;\n  }\n\n  .embed-preview-dialog .close-button:hover {\n    background: rgba(148, 163, 184, 0.12) !important;\n    color: #f8fafc !important;\n  }\n\n  .embed-preview-dialog .preview-frame-wrap,\n  .embed-preview-dialog .preview-loader {\n    background: #0f172a !important;\n    border-color: rgba(148, 163, 184, 0.3) !important;\n  }\n\n  .embed-preview-dialog .preview-loader p {\n    color: #cbd5e1 !important;\n  }\n\n  .embed-preview-dialog mat-icon,\n  .embed-preview-dialog .mat-icon {\n    color: #e2e8f0 !important;\n    fill: currentColor !important;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
